import React, { useEffect, useState } from 'react';
import { webApi } from '../services/api';
import { isCanceledRequest } from '../utils/abortRequest';
import { formatDateTime12hIST } from '../utils/dateDisplay';
import { AppHeader, EmptyState, LoadingState, SectionCard, StatusBanner } from '../components/ui';

function TipsPage() {
  const [period, setPeriod] = useState('month');
  const [tips, setTips] = useState([]);
  const [summary, setSummary] = useState({ totalCount: 0, totalAmount: 0 });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ac = new AbortController();
    const { signal } = ac;
    (async () => {
      try {
        setLoading(true);
        const data = await webApi.getTips({ period, limit: 30, offset: 0 }, { signal });
        if (signal.aborted) return;
        setTips(data?.tips || []);
        setSummary({
          totalCount: Number(data?.total || 0),
          totalAmount: Number(data?.totalAmount || 0)
        });
        setError('');
      } catch (err) {
        if (signal.aborted || isCanceledRequest(err)) return;
        setError(err.message || 'Failed to load tips');
      } finally {
        if (!signal.aborted) setLoading(false);
      }
    })();
    return () => ac.abort();
  }, [period]);

  if (loading) return <LoadingState message="Loading employer tips..." />;

  return (
    <div className="page">
      <AppHeader title="Tips" subtitle="Track all recent tips and totals." />
      <StatusBanner kind="error" message={error} />

      <SectionCard title="Filters">
        <div className="row">
          <select value={period} onChange={(e) => setPeriod(e.target.value)}>
            <option value="today">Today</option>
            <option value="week">Week</option>
            <option value="month">Month</option>
          </select>
          <p className="muted">
            Tips: {summary.totalCount} | Amount: Rs {summary.totalAmount.toLocaleString('en-IN')}
          </p>
        </div>
      </SectionCard>

      <SectionCard title="Tip Entries">
        {tips.length === 0 ? (
          <EmptyState message="No tips found for this period." />
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Employee</th>
                  <th>Amount</th>
                  <th>Type</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {tips.map((tip) => (
                  <tr key={tip.id}>
                    <td>{tip.id}</td>
                    <td>{tip.employeeName || '-'}</td>
                    <td>Rs {Number(tip.amount || 0).toLocaleString('en-IN')}</td>
                    <td>{tip.tipType || '-'}</td>
                    <td>{formatDateTime12hIST(tip.createdAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </SectionCard>
    </div>
  );
}

export default TipsPage;
